import { createSection } from '../createSection'

/**
 * Wrapper input section
 *
 * @public
 */
export const wrapper = createSection('wrapper', 'div')
